const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const ERdvService = {
    async getSites(motiveId: number) {
        const response = await fetch('/api/ERdv/GetSites?id=' + motiveId, {
            headers,
        });
        return await response.json();
    },
    async getMotiveLabel(serviceType: number, code: number) {
        const response = await fetch(
            `/api/ERdv/GetMotiveLabel?id=${code}&serviceId=${serviceType}`,
            { headers }
        );
        return await response.json();
    },

    async getServices(motiveId: string, siteId: string) {
        const request = {
            motiveId: motiveId,
            siteId: siteId,
        };
        const response = await fetch('/api/ERdv/GetServicesRequest/', {
            method: 'POST',
            body: JSON.stringify(request),
            headers,
        });
        return await response.json();
    },

    async getAvailabilities(
        codeSite: string,
        motiveId: number,
        serviceId: string,
        visitorUID: string
    ) {
        const request = {
            codeSite: codeSite,
            motiveId: motiveId,
            serviceId: serviceId,
            visitorUID: visitorUID,
        };

        const response = await fetch('/api/ERdv/GetAvailabilities/', {
            method: 'POST',
            body: JSON.stringify(request),
            headers,
        });
        return await response.json();
    },

    async lockTimeArea(
        date: Date,
        heureDebut: string,
        heureFin: string,
        codeService: string,
        codeSite: string,
        ressource: { id: number; key: string; type: string },
        motiveId: number,
        visitorUID: string
    ) {
        const request = {
            dateDebut: date,
            heureDebut: heureDebut,
            heureFin: heureFin,
            ressource: ressource,
            codeService: codeService,
            codeSite: codeSite,
            motiveId: motiveId,
            visitorUID: visitorUID,
        };

        const response = await fetch('/api/ERdv/LockTimeArea/', {
            method: 'PUT',
            body: JSON.stringify(request),
            headers,
        });
        return await response.json();
    },

    async takeAppointment(
        date: Date,
        heureDebut: string,
        heureFin: string,
        codeService: string,
        codeSite: string,
        motiveId: number,
        comment: string,
        ressource: { id: number; key: string; type: string },
        user: {
            civilite: number;
            niss: string;
            nom: string;
            prenom: string;
            telephone: string;
            mail: string;
        },
        captchaToken: string
    ) {
        if (user.niss === null) {
            user.niss = '11111111111';
        }

        const request = {
            date: date,
            heureDebut: heureDebut,
            heureFin: heureFin,
            ressource: ressource,
            codeService: codeService,
            codeSite: codeSite,
            motifId: motiveId,
            commentaire: comment,
            utilisateur: user,
            captchaToken: captchaToken,
        };

        const response = await fetch('/api/ERdv/TakeAppointment/', {
            method: 'PUT',
            body: JSON.stringify(request),
            headers,
        });
        return await response.json();
    },

    async getVisitorUID() {
        const response = await fetch('/api/ERdv/GetVisitorUID', { headers });
        return await response.json();
    },
};
